import Qrcode from 'vux/src/components/qrcode/index.vue'

import MeScroll from 'mescroll.js'
import 'mescroll.js/mescroll.min.css'

export default {
name: 'generalize',
components: {
Qrcode,
},
data () {
return {
qrCodeValue: '',
InvitationCode: {},
dataList: [],
page: 1,
mescroll: null,
isFixed: false,
offsetTop: 0,
listType: 'order',
listType2: 'order',
shareImgUrl: ''
}
},
methods: {
copy (str) {
var save = function(e){
e.clipboardData.setData('text/plain',str);
e.preventDefault();
}
document.addEventListener('copy',save);
document.execCommand('copy');
document.removeEventListener('copy',save);
this.$vux.toast.show({
type: 'success',
text: '复制成功'
})
},
share (type) {
let url = encodeURIComponent(this.qrCodeValue),
shareTitle = encodeURIComponent('齐思印触屏版'),
picurl = encodeURIComponent(this.shareImgUrl),
ua = navigator.userAgent.toLowerCase();
function shareToXl(){
var sharesinastring='http://v.t.sina.com.cn/share/share.php?title='+shareTitle+'&url='+url+'&content=utf-8&sourceUrl='+url+'&pic='+picurl;
window.open(sharesinastring)
}
if(ua.match(/MicroMessenger/i)=="micromessenger") { //微信自带浏览器
if(type == 'weibo'){
shareToXl()
}else{
alert('点击右上角即可分享')
}
} else {  //非微信自带浏览器
if(type == 'qq'){
this.$vux.toast.show({
type: 'success',
text: '复制成功，去粘贴分享给QQ好友吧'
})
this.copy(this.qrCodeValue)
setTimeout(() => {
window.location.href = 'mqqwpa://im/chat?chat_type=wpa&version=1&src_type=web&web_src=oicqzone.com';
}, 1000);
}else if(type == 'zome'){
var share = 'https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url='+url+'&sharesource=qzone&title='+shareTitle+'&pics='+picurl+'&summary='+shareTitle+''
window.location.href = share
}else if(type == 'weibo'){
shareToXl()
}
}
},
toggleOrderVoucher (type) {
this.$vux.loading.show({
text: ''
})
this.listType = ''
this.listType2 = type
setTimeout(() => {
this.listType = type
}, 400);
console.log(type)
this.mescroll.resetUpScroll()
this.mescroll.scrollTo( 0, 0 )
},
copylink () {
this.copy(this.$refs.copyText.innerText)
},

upCallback (page) {

this.getListDataFromNet(this.pdType, page.num, page.size, (arr) => {


if (page.num === 1) this.dataList = []

this.dataList = this.dataList.concat(arr)

this.$nextTick(() => {
this.mescroll.endSuccess(arr.length)

this.$vux.loading.hide()

})
}, () => {
this.mescroll.endErr()
})
},
/* 联网加载列表数据
* 在您的实际项目中,请参考官方写法: http://www.mescroll.com/api.html#tagUpCallback
* 请忽略getListDataFromNet的逻辑,这里仅仅是在本地模拟分页数据,本地演示用
* 实际项目以您服务器接口返回的数据为准,无需本地处理分页.
*/
getListDataFromNet (pdType, pageNum, pageSize, successCallback, errorCallback) {
console.log(22)
this.mescroll.lockUpScroll( false )
console.log(this.listType2)
if(this.listType2 == 'order'){
this.$request.post('/user/getInvitationCode',{
page: pageNum,
rows: pageSize
}).then(data => {
if(data.code == 0){
this.InvitationCode = {...data.obj}

this.qrCodeValue = location.origin+'/#/?inviteCode='+this.InvitationCode.ownCode
console.log(this.$baseURL)
this.$nextTick(() => {
this.$request.post('/quotation/base64ToOss',{
imagePath: document.getElementsByClassName('qrCode')[0].getElementsByTagName('img')[0].src
}).then(data => {
if(data.code == 0){

}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
this.shareImgUrl = e

this.$shareList(this.shareImgUrl, this.qrCodeValue, '齐思印触屏版', '本网提供专业的3d打印报价,多年行业经验,3d打印应用领域广,高效率,高精度,售后完善')
console.log(e)
})
})
setTimeout(() => {

var listData = []
for (var i = (pageNum - 1) * pageSize; i < pageNum * pageSize; i++) {
if (i === data.obj.orderData.total){
console.log('没啦')
break
}
listData.push(data.obj.orderData.rows[i-(pageNum - 1) * pageSize])
}
successCallback(listData)
}, 350);
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
}else{
this.$request.post('/couponDetail/getInvitationCouponUserInfo',{
page: pageNum,
rows: pageSize
}).then(data => {
if(data.code == 0){
setTimeout(() => {

var listData = []
for (var i = (pageNum - 1) * pageSize; i < pageNum * pageSize; i++) {
if (i === data.obj.total){
console.log('没啦')
break
}
listData.push(data.obj.rows[i-(pageNum - 1) * pageSize])
}
successCallback(listData)
}, 350);
}else{
this.$vux.loading.hide()
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
this.$vux.loading.hide()
console.log(e)
})
}
},
initMescrollFun () {

this.mescroll = new MeScroll(this.$refs.mescroll, { // 在vue的mounted生命周期初始化mescroll,确保此处配置的ref有值
up: {
callback: this.upCallback,
htmlNodata: '<p class="upwarp-nodata">没有更多数据</p>',
page: {
num: 0, // 当前页码,默认0,回调之前会加1,即callback(page)会从1开始
size: 10 
},
noMoreSize: 1, // 如果列表已无数据,可设置列表的总数量要大于等于5条才显示无更多数据;避免列表数据过少(比如只有一条数据),显示无更多数据会不好看
toTop: { // 配置回到顶部按钮
src: require('../../assets/images/mescroll-totop.png'),
offset: 100
},
empty: {

warpId:	"dataList", //父布局的id (1.3.5版本支持传入dom元素)

tip: "暂无相关数据~", //提示
},
onScroll: this.onScroll



},
down: {
offset: 40,




}
})
},
onScroll (mescroll, y, isUp) {
this.isFixed = (y+17) > this.offsetTop ? true : false;

},
},
created () {

},
mounted() {
this.initMescrollFun()
this.$nextTick(() => {

this.offsetTop = document.querySelector('#boxFixed').offsetTop;
})
},
beforeRouteEnter (to, from, next) { // 如果没有配置回到顶部按钮或isBounce,则beforeRouteEnter不用写
next(vm => {
if (vm.mescroll) {

if (vm.mescroll.lastBounce != null) vm.mescroll.setBounce(vm.mescroll.lastBounce)

if (vm.mescroll.lastScrollTop) {
vm.mescroll.setScrollTop(vm.mescroll.lastScrollTop)
setTimeout(() => { // 需延时,因为setScrollTop内部会触发onScroll,可能会渐显回到顶部按钮
vm.mescroll.setTopBtnFadeDuration(0)
}, 16)
}
}
})
},
beforeRouteLeave (to, from, next) { // 如果没有配置回到顶部按钮或isBounce,则beforeRouteLeave不用写
if (this.mescroll) {
this.mescroll.lastBounce = this.mescroll.optUp.isBounce
this.mescroll.setBounce(true) 
this.mescroll.lastScrollTop = this.mescroll.getScrollTop() 
this.mescroll.hideTopBtn(0)
}
next()
},
}



// WEBPACK FOOTER //
// ./src/views/generalize/script.js